const Navigation = () => null;

export default Navigation;
